import { FormControl, FormControlLabel } from '@mui/material';

import MyDialog from "~/mui/MyDialog";
import { formatBillingHistoryRange } from '~/utils/utils';
import { useTrans } from '~/hooks/useTrans';
import { IUrlParams } from "~/interfaces";
import { IProjectBillingHistory } from "~/providers/interfaces";
import { apiToggleProjectBillingDebt } from "~/providers/api";
import { myUseState } from "~/hooks/myUseState";
import { MySwitch } from "~/mui/MySwitch";
import { useLang } from "~/hooks/useLang";

interface IState {
	dialogLoading: boolean;
	errorMsg: string;
	checked: boolean;
}

interface IAdminSetDebtModal {
	params: IUrlParams;
	billing: IProjectBillingHistory
	onSave?: () => void;
	onClose?: () => void;
}

export default function AdminSetDebtModal({
	params = null,
	billing,
	onSave = () => {},
	onClose = () => {},
}: IAdminSetDebtModal) {
	const { trans } = useTrans();
	const { lang, isCzech } = useLang();
	const { state, updateState } = myUseState<IState>({
		dialogLoading: false,
		errorMsg: "",
		checked: billing.amountTotal === billing.debt,
	});

	async function dialogOnSave() {
		updateState({
			dialogLoading: true,
			errorMsg: "",
		});

		const toggleData = await apiToggleProjectBillingDebt("admin", params.projectId, billing.id, state.checked, lang);

		if (toggleData.noErrors) {
			onSave();
		} else {
			updateState({
				dialogLoading: false,
				errorMsg: toggleData.errors.join(", "),
			});
		}
	}

	return <MyDialog title={trans("adminSetDebtModal.title")} onClose={onClose} onSave={dialogOnSave} className="adminSetDebthModal" dialogLoading={state.dialogLoading}
		errorMsg={state.errorMsg} saveCaption={trans("saveChanges")} minWidth="300px">
		<FormControl sx={{ width: "100%" }}>
			<FormControlLabel
				control={<MySwitch sx={{ m: 1 }} checked={state.checked} onChange={event => updateState({ checked: event.target.checked })} />}
				label={ trans("adminSetDebtModal.debtRange", { range: formatBillingHistoryRange(billing, isCzech) })}
			/>
		</FormControl>
	</MyDialog>;
}
